import type { ConversationSummary } from '../domain/conversations';
import { fullName } from './people';

/** A conversation's name, or the other people in it when it has none. */
export function conversationTitle(c: Pick<ConversationSummary, 'name' | 'otherPeople'>): string {
  return c.name || c.otherPeople.map(fullName).join(', ') || 'Just you';
}
